<template>
  <div class="mapRouting-container">
    <!-- The component does not contain a visual map, but handles routing logic -->
  </div>
</template>

<script>
export default {
  name: "RoutingMTK",

  props: {
    start: Array,
    end: Array,
    mode: String,
    calculate: Number,
    selecting: String,
    initialLat: {type: Number},
    initialLng: {type: Number},
    initialZoom: {type: Number}
  },

  data() {
    return {
      currentSelecting: "start",
      localStart: null,
      localEnd: null
    };
  },

  watch: {
    start(newVal) {
      console.log("start prop updated:", newVal);
      this.localStart = newVal;
    },
    end(newVal) {
      console.log("end prop updated:", newVal);
      this.localEnd = newVal;
    },
    selecting(newVal) {
      console.log("Selecting changed to:", newVal);
      this.currentSelecting = newVal;
    },
    calculate() {
      console.log("Manual trigger for route calculation");
      this.tryCalculateRoute();
    }
  },

  methods: {
    emitReset() {
      this.$emit("routeReset");
    },

    tryCalculateRoute() {
      if (this.localStart && this.localEnd) {
        this.calculateRoute(this.localStart, this.localEnd, this.mode);
      } else {
        console.log("Waiting for valid coordinates to calculate route...");
      }
    },

    async calculateRoute(start, end, mode) {
      if (!start || !end) {
        console.warn("[Abort] Start or End is missing");
        return;
      }

      const [lat1, lon1] = start;
      const [lat2, lon2] = end;
      const url = `https://routing.maptoolkit.net/route?point=${lat1},${lon1}&point=${lat2},${lon2}&routeType=${mode}&language=en&api_key=93563e3c-84df-435d-a44e-7a6c24e0d817`;

      try {
        const res = await fetch(url);
        const data = await res.json();
        console.log("[Response] received from API:", data);

        if (!data.paths || !data.paths[0]) {
          console.error("[Error] No valid response:", data);
          return;
        }
        const path = data.paths[0];
        const coords = window.polyline.decode(path.points).map(c => c.reverse());

        const summary = {
          distance: path.distance,
          duration: path.time / 1000
        };
        this.$emit("routeCalculated", {coords, summary});
      } catch (error) {
        console.error("[Catch] Error during fetch or processing:", error);
      }
    },

    handleMapClick(e) {
      const coords = [e.lngLat.lat, e.lngLat.lng];
      this.$emit("mapClicked", coords);

      if (this.currentSelecting === "start") {
        this.localStart = coords;
        this.$emit("startSelected", coords);
      } else if (this.currentSelecting === "end") {
        this.localEnd = coords;
        this.$emit("endSelected", coords);
      }

      this.tryCalculateRoute();
    }
  }
};
</script>

<style scoped>
.mapRouting-container {
  display: flex;
  width: 100%;
  height: 100%;
}
</style>
